'use client';
import React from 'react';
import StatusCard from '@/app/components/ui/StatusCard';
import Link from 'next/link';

export default function NotFoundPage() {
  return (
    <div className="grid min-h-svh w-screen max-w-screen grid-rows-[48px_1fr_48px] sm:grid-rows-[65px_1fr_65px_33px] grid-cols-[15px_1fr_15px] sm:grid-cols-[45px_1fr_60px]">
      <div></div>
      <div className="border-x border-border"></div>
      <div></div>
      <div className="border-y border-border"></div>
      <div className="relative border border-border p-5 lg:pr-[10px]">
        <div className="absolute rounded-full top-0 left-0 w-[6px] h-[6px] bg-muted -translate-[3.5px]"></div>
        <div className="absolute rounded-full right-0 top-0 w-[6px] h-[6px] bg-muted transform translate-x-[3.5px] -translate-y-[3.5px]"></div>
        <div className="absolute rounded-full left-0 top-full w-[6px] h-[6px] bg-muted transform -translate-[3.3px]"></div>
        <div className="absolute rounded-full left-full top-full w-[6px] h-[6px] bg-muted transform -translate-[2.5px]"></div>

        <div className="flex flex-col max-w-full   justify-center h-full gap-6">
          <Link
            href={`${process.env.NEXT_PUBLIC_URL}`}
            className="text-[28px] font-semibold leading-none text-foreground"
          >
            1eye
          </Link>
          <StatusCard
            className="border-0 shadow-none"
            type="error"
            heading="404 - Not Found"
            text="We couldn't find the page you were looking for. Please check the URL or use the sidebar to navigate."
            actionLabel="Go to Home"
            onAction={() => (window.location.href = '/')}
          />
        </div>
      </div>
      <div className="border-y border-border"></div>

      <div className="sm:border-b border-border relative">
        <div className="hidden sm:block absolute rounded-full bottom-0 right-0 w-[6px] h-[6px] bg-muted transform translate-[3.5px]"></div>
      </div>
      <div className="flex items-center pl-6 border-x sm:border sm:border-t-0 border-border">
        <p className="text-sm text-muted-foreground">1eye AI, Inc. | Palo Alto, CA</p>
      </div>
      <div className="sm:border-b border-border relative">
        <div className="hidden sm:block absolute rounded-full bottom-0 left-0 w-[6px] h-[6px] bg-muted transform -translate-x-[3.5px] translate-y-[3.5px]"></div>
      </div>

      <div className="hidden sm:inline-grid"></div>
      <div className="hidden sm:inline-grid border-x border-border"></div>
      <div className="hidden sm:inline-grid"></div>
    </div>
  );
}
